import { FormControl, FormHelperText, Paper } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Tab, Tabs, Typography, Grid, MenuItem, Checkbox } from "@mui/material";
import { Box } from "@mui/system";

import { useEffect, useState } from "react";
import axios from "axios";
import { json } from "react-router";
import { VStack } from "Components";

import { QA_DOMAIN } from "config/config";
import { GPTQA_API_PATHS } from "./constants/api-paths";
import { PdfUploader } from "./pdf-uploader";
import { backendConnector, DATA_LINK } from "connectors";

interface IProjectStatus {
  _id: string;
  alias: string;
  enabled: boolean;
  status: "preparing" | "ready" | "error";
  text_file?: {
    available: boolean;
    name: string;
    location: string;
  };
  original_file?: {
    available: boolean;
    name: string;
    location: string;
  };
  reference: {
    link: string;
    title: string;
    target: "blank" | "self";
  };
}

interface IProps {
  addOns?: { project?: string };
  setAddOns?: (addOns: any) => void;
}

const SettingPanel = ({ addOns, setAddOns }: IProps) => {
  const [availableProject, setAvailableProject] = useState<IProjectStatus[]>([]);
  const [project, setProject] = useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setProject(event.target.value);
    if (setAddOns) setAddOns({ ...addOns, project: event.target.value });
  };

  useEffect(() => {
    (async () => {
      const respone = await backendConnector.post(DATA_LINK.DMList, { filterControl: true });
      const projects = respone.payload.docs;
      setAvailableProject(projects);
    })();
  }, []);

  const getUpdates = async () => {
    const respone = await backendConnector.post(DATA_LINK.DMList);
    const projects = respone.payload.docs;
    setAvailableProject(projects);
  };

  return (
    <VStack width={"100%"} sx={{ justifyContent: "start" }}>
      <Typography fontWeight={"bold"}>Choose a file</Typography>
      <FormControl fullWidth error={!project}>
        <Select fullWidth value={project} onChange={handleChange}>
          <MenuItem key={-1} value="All">
            All
          </MenuItem>
          {availableProject?.map((o, i) => {
            if (o.enabled) {
              return (
                <MenuItem key={i} value={o._id} disabled={o.status !== "ready" && o._id != "All"}>
                  {o.alias != "All" && o.status !== "ready" ? o.alias + "       (Processing)" : o.alias}
                </MenuItem>
              );
            }
          })}
        </Select>
        {!project && <FormHelperText>Choose a project</FormHelperText>}
      </FormControl>

      <Box sx={{ width: "100%", height: "5%" }} />
      {/* <PdfUploader onUpdate={getUpdates} /> */}
    </VStack>
  );
};

export default SettingPanel;
